import React from 'react'
import Apollo from './src/providers/Apollo'
import { registerLocale } from 'react-datepicker'
import ru from 'date-fns/locale/ru'
import moment from 'moment'

import "typeface-montserrat"
import "typeface-merriweather"

import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/ru'


moment.locale('ru')
registerLocale('ru', ru)

export const wrapRootElement = ({ element }) => (
  <Apollo>
    {element}
  </Apollo>
)